import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DefaultButton, Dropdown, Panel, PrimaryButton, SpinButton, Stack} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";

function AddProjectDocument(props) {
    const [user] = useContext(AuthContext);
    const [file, setFile] = useState(null);
    const [type, setType] = useState(null);
    const [types, setTypes] = useState([]);
    const [number, setNumber] = useState(1);

    const _submit = (e) => {
        e.preventDefault();
        if (file !== null) {
            const data = new FormData();
            data.append('document', file);
            data.append('document_type_id', type?.key);
            data.append('number', number);
            fetch(`/api/project/${props.add}/document`, {
                method: 'POST',
                body: data,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(json => {
                    props.onSuccess(json);
                    props.dismissPanel();
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }

    useEffect(() => {
        setType(null);
        const abortController = new AbortController();
        if (props.add) {
            async function fetchTypes() {
                await fetch(`/api/document`, {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                        'Authorization': 'Bearer ' + user.token
                    }
                }).then(res => res.json())
                    .then(data => {
                        setTypes(data.map((item) => {
                            return {key: item.id, text: item.type};
                        }))
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
            fetchTypes();
        }
        return () => abortController.abort();
    }, [props.add, user.token])

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddProjectDocument'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Dokument"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddProjectDocument'>
                <Dropdown
                    label="Typ"
                    selectedKey={type ? type.key : undefined}
                    onChange={(e, item) => setType(item)}
                    placeholder="Wybierz z listy"
                    options={types}
                />
                <SpinButton
                    label={'Numer'}
                    labelPosition={'top'}
                    min={1}
                    step={1}
                    incrementButtonAriaLabel={'Increase value by 1'}
                    decrementButtonAriaLabel={'Decrease value by 1'}
                    value={number}
                    onChange={(e, val) => setNumber(val)}
                />
                <br/>
                <input type="file" name="file" onChange={(e) => setFile(e.target.files[0])}/>
            </form>
        </Panel>
    )
}

export default AddProjectDocument;